import AudioPreview from './AudioPreview';

export default AudioPreview;
